import React from "react";
import { Redirect, Route, Switch } from "react-router";
import TeeOnPortalBooking from "./TeeOnPortalBooking/TeeOnPortalBooking";
import TeeOnPortalBookingConfirmation from "./TeeOnPortalBookingConfirmation/TeeOnPortalBookingConfirmation";
import TeeOnPortalHome from "./TeeOnPortalHome/TeeOnPortalHome";
import "./teeOnPortalMain.scss";
import TeeOnPortalNavigation from "./TeeOnPortalNavigation/TeeOnPortalNavigation";
import TeeOnPortalCourses from "./TeeOnPortalCourses/TeeOnPortalCourses";

export default function TeeOnPortalMain() {
  return (
    <div className="tee-on-booking-portal">
      <TeeOnPortalNavigation />
      <div className="tee-on-booking-portal-main-container">
        <Switch>
          <Route path={"/booking/teetimes/golf-courses"} component={TeeOnPortalCourses} />
          <Route exact path={"/booking/teetimes/book"} component={TeeOnPortalBooking} />
          <Route exact path={"/booking/teetimes/confirm"} component={TeeOnPortalBookingConfirmation} />
          <Route path={"/booking/teetimes/:facilityShortName?"} component={TeeOnPortalHome} />
          <Redirect to="/booking/teetimes/:facilityShortName?" />
        </Switch>
      </div>
    </div>
  );
}
